import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import InputComponent from "../../../components/InputComponent";
import SearchSelectComponent from "../../../components/SearchSelectComponent";
import Routes from "../../../helpers/Routes";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import {
  CreateAssistanceDTO,
  CreateAssistanceDTOSchema,
} from "../../../models/Assistance/CreateAssistanceDTO";
import { EquipmentDTO } from "../../../models/Equipment/EquipmentDTO";
import { SearchByCarPlate } from "../../../models/Equipment/SearchByCarPlate";
import { SearchByNSerie } from "../../../models/Equipment/SearchByNSerie";
import { AssistanceService } from "../../../services/AssistanceService";
import { EquipmentService } from "../../../services/EquipmentService";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";
import { useIntl } from "react-intl";
import { ProjectDTO } from "../../../models/Project/ProjectDTO";
import ClientEquipmentBidirecional from "../../ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import SelectComponent from "../../SelectComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import React from "react";
import { RenderCountersInputs } from "../RenderCountersInputs";

export type SelectItemsProps = {
  label: string;
  value: string;
};

export default function AssistanceCreateB() {
  const navigate = useNavigate();
  const equipmentService = new EquipmentService();
  const assistanceService = new AssistanceService();
  const [isButtonCreateLoading, setIsButtonCreateLoading] =
    useState<boolean>(false);
  useState<boolean>(false);
  const [assistance, setAssistance] = useState<AssistanceDTO>({
    date: new Date(),
  } as AssistanceDTO);
  const searchRef = useRef<boolean>(true);
  const [project, setProject] = useState<ProjectDTO>({} as ProjectDTO);
  const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>({
    counter1: 0,
    counter2: 0,
    counter3: 0,
  } as TimeHistoryDTO);

  // props para novo componente
  const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
  const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
  const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
  const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(null);
  const [equipment, setEquipment] = useState<EquipmentDTO>({} as EquipmentDTO);
  const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
  const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(null);

  const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
  const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

  const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
  const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);

  useEffect(() => {
    if (availableModules.includes("IsActiveCountersModule")) {
      setIsActiveCountersModule(true);
    }
  }, [availableModules]);


  //obter tipo de assistencia
  useEffect(() => {
    getAssistanceTypes();
  }, []);
  const getAssistanceTypes = async () => {
    const list: SelectItemsProps[] = [];

    assistanceTypes.forEach((element) => {
      var item: SelectItemsProps = {
        value: element,
        label: element,
      };
      list.push(item);
    });

    setAssistanceTypesComponent(list);
  };


  const createAssistance = async () => {
    var sendData: CreateAssistanceDTO = {
      id: assistance.id,
      date: assistance.date,
      description: assistance.description,
      notes: assistance.notes,
      equipmentErpId: equipment.erpId != undefined ? equipment.erpId : "",
      equipmentName: equipment.name != undefined ? equipment.name : null,
      equipmentNumSerie: equipment.erpId != undefined ? equipment.serialNumber : null,
      equipmentBrand: equipment.erpId != undefined ? equipment.brand : null,
      equipmentModel: equipment.erpId != undefined ? equipment.model : null,
      projectErpId: project.erpId != undefined ? project.erpId : null,
      clientErpId: equipment?.client?.erpId ?? clientSelected?.value ?? null,
      typeDoc: "FO",
      numDoc: null,
      serie: null,
      clientId: null,
      counter1: Number(timeHistory.counter1) || 0,
      unit1: timeHistory.unit1,
      counter2: Number(timeHistory.counter2) || 0,
      unit2: timeHistory.unit2,
      counter3: Number(timeHistory.counter3) || 0,
      unit3: timeHistory.unit3,
      assistanceType: selectedAssistanceType || "Reparação",
      stockEntryDocumentErpId: null,
      budgetSellingPrice: assistance.budgetSellingPrice ?? null,
      budgetCostPrice: assistance.budgetCostPrice ?? null
    };

    var responseValidate = CreateAssistanceDTOSchema.validate(sendData, {
      allowUnknown: true,
    });

    if (responseValidate.error != null) {
      var message = responseValidate.error!.message;
      Toast.Show("error", message);
      return false;
    }

    setIsButtonCreateLoading(true);
    var response = await assistanceService.CreateInDbAndErp(sendData);
    setIsButtonCreateLoading(false);

    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      return;
    }
    Toast.Show("success", response.message);
    navigate(`${Routes.backoffice.details}/${response.obj}`);
  };

  const intl = useIntl();

  return (
    <>
      <label style={{ margin: "0px", padding: "13px" }}>
        <b>Informação Geral</b>
      </label>
      <Col xl={6}>
        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >
          <SelectComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%", height: "43px" }}
            label={"Tipo de Assistência"}
            selectedItemValue={selectedAssistanceType}
            items={assistanceTypesComponent}
            onChange={(t: string) => {
              setSelectedAssistanceType(t);
            }}
          />
        </Row>
        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >
          <ClientEquipmentBidirecional
            isActiveProjectModule={isActiveProjectModule}
            projectSelected={projectSelected}
            clientSelected={clientSelected}
            setClientSelected={setClientSelected}
            serialNumberSelected={serialNumberSelected}
            setSerialNumberSelected={setSerialNumberSelected}
            equipment={equipment}
            setEquipment={setEquipment}
            isSearchEquipmentLoading={isSearchEquipmentLoading}
            setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}
            isActiveSearchByCarPlate={true}
            carPlateSelected={carPlateSelected}
            setCarPlateSelected={setCarPlateSelected}
          />
        </Row>
        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >
          <InputComponent
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            style={{ width: "100%" }}
            type={"date"}
            value={Utilities.formatDateYYYYMMDD(assistance.date)}
            label={"Dia"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({
                ...assistance,
                date: new Date(
                  `${t}T${Utilities.GetTimeFromDateTime(
                    assistance.date
                  )}`
                ),
              });
            }}
          />

          <InputComponent
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            style={{ width: "100%" }}
            type={"time"}
            value={Utilities.GetTimeFromDateTime(assistance.date)}
            label={"Hora"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({
                ...assistance,
                date: new Date(
                  `${Utilities.formatDate(
                    assistance.date
                  )}T${t}`
                ),
              });
            }}
          />
        </Row>

        {/* Estado 2 - Contadores */}
        {isActiveCountersModule && (
          <>
            <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
              {intl.formatMessage({ id: "Screens.AssistanceCreateB.CountersTitle" })}
            </label>
            <Row style={{ margin: "0px", padding: "0px" }}>
              {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory)}
            </Row>
          </>
        )}

        {/* Estado 3 - Descrições */}
        <Row style={{ margin: "0px", padding: "0px" }}>
          <InputComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%" }}
            type={"textArea"}
            value={assistance?.description}
            label={"Descrição do Serviço"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({ ...assistance, description: t });
            }}
          />
        </Row>
        <Row style={{ margin: "0px", padding: "0px" }}>
          <InputComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%" }}
            type={"textArea"}
            value={assistance?.notes}
            label={"Observações"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({ ...assistance, notes: t });
            }}
          />
        </Row>
        <Row style={{ margin: "0px", padding: "0px" }}>
          <Col xl={1} lg={1} md={1} sm={1} xs={1}>
            <ButtonComponent
              loading={isButtonCreateLoading}
              style={{ width: "100%", marginTop: "10px" }}
              text={intl.formatMessage({ id: "AssistanceCreateB.Save" })}
              onClick={() => createAssistance()}
            />
          </Col>
        </Row>
      </Col>
    </>
  );
}
